exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "dl.complex-raw{list-style-type:none;margin:5px 0 10px 0}dl.complex-raw dl.complex-raw{padding-left:2ch}dl.complex-raw dt{font-weight:bold}", ""]);

// exports
